<mat-form-field fxFlex="100">
    <input matInput 
        name="slideCount" 
        autocomplete="slideCount"
        id="slideCount{{inputRand}}"
        placeholder="Number of Slides" 
        [formControl]="control" 
        [matAutocomplete]="slideCountAuto"
        [readonly]="canEdit === false" >
</mat-form-field>
<mat-autocomplete #slideCountAuto="matAutocomplete">
    <mat-option *ngFor="let option of options" [value]="option">
        {{ option }}
    </mat-option>
</mat-autocomplete>